/**
 * Marketing tracking API endpoints (FRO-10957).
 * Backend implementation tracked in BAC-2786 (universal-service). Until that
 * lands, MarketingServices resolves mock data instead of calling these.
 */
export default {
	dashboard: "marketing/dashboard",
	filterOptions: "marketing/filter-options",
	trackingRecords: "marketing/tracking-records",
	campaigns: "marketing/campaigns"
};
